import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchProducts, formatUsd } from "../lib/api";
import { HOME } from "../constants/testIds";

export default function ShopPage() {
  const [products, setProducts] = useState([]);
  useEffect(() => { fetchProducts().then(setProducts); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 lg:py-24">
      <div className="max-w-2xl">
        <div className="eyebrow">The Full Collection</div>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4">Shop All Recovery Systems</h1>
        <p className="mt-6 text-[#6B5757] leading-relaxed">
          Six systems, each engineered around a specific procedure. Every kit ships in medical-grade packaging with a printed and digital protocol.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
        {products.map((p) => (
          <Link
            key={p.id}
            to={`/products/${p.id}`}
            data-testid={HOME.procedureCard(p.id)}
            className="group block"
          >
            <div className="relative aspect-[3/4] overflow-hidden bg-[#FDF3ED]">
              <img src={p.image} alt={p.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute top-4 right-4 bg-[#FBF6F1] px-3 py-1 font-mono text-[10px] tracking-widest">
                {p.duration_weeks}-WK
              </div>
            </div>
            <div className="mt-5 flex items-start justify-between gap-4">
              <div>
                <div className="eyebrow">{p.procedure}</div>
                <h3 className="font-serif text-xl mt-2 group-hover:text-[#B85C56] transition-colors">{p.name}</h3>
                <p className="text-xs text-[#6B5757] mt-2 leading-relaxed">{p.subtitle}</p>
              </div>
              <div className="text-right">
                <div className="font-serif text-lg">{formatUsd(p.price)}</div>
                <div className="font-mono text-[10px] text-[#A08D8D]">★ {p.rating}</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
